/* List of Redux constants */
export const CANDIDATE_PROFILE_SET_BIOGRAPHICAL_INFORMATION =
  '@candidate-profile/set-biographical-information';
export const CANDIDATE_PROFILE_SET_HOUSING_PREFERENCES =
  '@candidate-profile/set-housing-preferences';
export const CANDIDATE_PROFILE_SET_HEALTH = '@candidate-profile/set-health';
export const CANDIDATE_PROFILE_SET_SPORT_ACTIVITIES =
  '@candidate-profile/set-sport-activities';
export const CANDIDATE_PROFILE_SET_LANGUAGES =
  '@candidate-profile/set-languages';
export const CANDIDATE_PROFILE_SET_LOADING_LOADER =
  '@candidate-profile/set-loading-loader';
export const CANDIDATE_PROFILE_SET_PROFILE_SECTIONS_STATES_LOADING_LOADER =
  '@candidate-profile/set-profile-sections-states-loading-loader';
export const CANDIDATE_PROFILE_SET_SUBMITTING_LOADER =
  '@candidate-profile/set-submitting-loader';
export const CANDIDATE_PROFILE_SET_PROFILE_SECTIONS_STATES =
  '@candidate-profile/set-profile-sections-states';
export const CANDIDATE_PROFILE_RESET_PROFILE_STATE =
  '@candidate-profile/reset-profile-state';
export const CANDIDATE_PROFILE_SET_PERSONAL = '@candidate-profile/set-personal';
export const CANDIDATE_PROFILE_SET_SECONDARY_SCHOOLS =
  '@candidate-profile/set-secondary-schools';
export const CANDIDATE_PROFILE_SET_TEACHING_EXPERIENCE =
  '@candidate-profile/set-teaching-experience';
export const CANDIDATE_PROFILE_SET_CONTACT_INFORMATION =
  '@candidate-profile/set-contact-information';
export const CANDIDATE_PROFILE_SET_UNIVERSITIES_COLLEGES =
  '@candidate-profile/set-universities-colleges';
export const CANDIDATE_PROFILE_SET_TEACHING_CREDENTIALS =
  '@candidate-profile/set-teaching-credentials';

/* List of Sagas constants */
export const CANDIDATE_PROFILE_FETCH_PROFILE_SECTIONS_STATES =
  '@candidate-profile/fetch-profile-sections-states';
export const CANDIDATE_PROFILE_FETCH_BIOGRAPHICAL_INFORMATION =
  '@candidate-profile/fetch-biographical-information';
export const CANDIDATE_PROFILE_SUBMIT_BIOGRAPHICAL_INFORMATION =
  '@candidate-profile/submit-biographical-information';
export const CANDIDATE_PROFILE_FETCH_HOUSING_PREFERENCES =
  '@candidate-profile/fetch-housing-preferences';
export const CANDIDATE_PROFILE_SUBMIT_HOUSING_PREFERENCES =
  '@candidate-profile/submit-housing-preferences';
export const CANDIDATE_PROFILE_FETCH_HEALTH = '@candidate-profile/fetch-health';
export const CANDIDATE_PROFILE_SUBMIT_HEALTH =
  '@candidate-profile/submit-health';
export const CANDIDATE_PROFILE_FETCH_SPORT_ACTIVITIES =
  '@candidate-profile/fetch-sport-activities';
export const CANDIDATE_PROFILE_SUBMIT_SPORT_ACTIVITIES =
  '@candidate-profile/submit-sport-activities';
export const CANDIDATE_PROFILE_FETCH_LANGUAGES =
  '@candidate-profile/fetch-languages';
export const CANDIDATE_PROFILE_SUBMIT_LANGUAGES =
  '@candidate-profile/submit-languages';
export const CANDIDATE_PROFILE_FETCH_PERSONAL =
  '@candidate-profile/fetch-personal';
export const CANDIDATE_PROFILE_SUBMIT_PERSONAL =
  '@candidate-profile/submit-personal';
export const CANDIDATE_PROFILE_FETCH_SECONDARY_SCHOOLS =
  '@candidate-profile/fetch-secondary-schools';
export const CANDIDATE_PROFILE_SUBMIT_SECONDARY_SCHOOLS =
  '@candidate-profile/submit-secondary-schools';
export const CANDIDATE_PROFILE_SUBMIT_TEACHING_EXPERIENCE =
  '@candidate-profile/submit-teaching-experience';
export const CANDIDATE_PROFILE_FETCH_TEACHING_EXPERIENCE =
  '@candidate-profile/fetch-teaching-experience';
export const CANDIDATE_PROFILE_SUBMIT_CONTACT_INFORMATION =
  '@candidate-profile/submit-contact-information';
export const CANDIDATE_PROFILE_FETCH_CONTACT_INFORMATION =
  '@candidate-profile/fetch-contact-information';
export const CANDIDATE_PROFILE_FETCH_UNIVERSITIES_COLLEGES =
  '@candidate-profile/fetch-universities-colleges';
export const CANDIDATE_PROFILE_SUBMIT_UNIVERSITIES_COLLEGES =
  '@candidate-profile/submit-universities-colleges';

export const CANDIDATE_PROFILE_FETCH_TEACHING_CREDENTIALS =
  '@candidate-profile/fetch-teaching-credentials';
export const CANDIDATE_PROFILE_SUBMIT_TEACHING_CREDENTIALS =
  '@candidate-profile/submit-teaching-credentials';

export const CANDIDATE_PROFILE_GET_ALL_SECTIONS =
  '@candidate-profile/get-all-sections';



// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-profile/types.js